import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a17fbf0d6425f00149b3272_1781774361987_0d722a5f/landingclone/src/app/faq/page.tsx");
